import * as THREE from 'three';

// Art-directed ambient response for small characters. Preserve direct lighting
// and highlights, but soften the green cast and recover shape in low fill light.
// With no incident light the result is still black; this is not emission.
export function personAmbient(rgb) {
  const l=rgb[0]*.2126+rgb[1]*.7152+rgb[2]*.0722;
  const gain=THREE.MathUtils.lerp(1.8,1.05,THREE.MathUtils.smoothstep(l,.15,.7));
  return rgb.map(c=>THREE.MathUtils.lerp(c,l,.4)*gain);
}

function ambientShader(shader) {
  shader.fragmentShader=shader.fragmentShader.replace('#include <lights_fragment_end>',`
    float personAmbientLuma=dot(irradiance,vec3(.2126,.7152,.0722));
    float personAmbientGain=mix(1.8,1.05,smoothstep(.15,.7,personAmbientLuma));
    irradiance=mix(irradiance,vec3(personAmbientLuma),.4)*personAmbientGain;
    #include <lights_fragment_end>
  `);
}

export class PersonDiffuseMaterial extends THREE.MeshLambertMaterial {
  constructor(parameters={}) {super(parameters);this.isPersonSurfaceMaterial=true;}
  customProgramCacheKey(){return 'person-diffuse-ambient-v1';}
  onBeforeCompile(shader){ambientShader(shader);}
}

export class PersonHairMaterial extends THREE.MeshPhongMaterial {
  constructor(parameters={}) {super(parameters);this.isPersonSurfaceMaterial=true;}
  customProgramCacheKey(){return 'person-hair-ambient-v1';}
  onBeforeCompile(shader){ambientShader(shader);}
}
